module.exports = __webpack_public_path__ + "static/media/thumbnail.9ab510a1.jpg";